module.exports = __webpack_public_path__ + "img/p42.82aaa3be.png";